export const Konami = (() => {
	'use strict';
	let timer,
		keys = [],
		konami = [38, 38, 40, 40, 37, 39, 37, 39, 66, 65];

	function init() {

		$(window).on('keyup', function(e) {
			keys.push(e.keyCode);
			clearTimeout(timer);
			timer = setTimeout(clearKeys, 1000);

			if ( arraysEqual(keys, konami) ) {
				console.warn('The man, the myth, the legend: Scott Griesbach https://www.linkedin.com/in/scottgriesbach/');
				console.log('We don\'t know where we would be without him, but certainly it wouldn\'t be here');
			}
		});
	}

	function clearKeys() {
		keys = [];
	}

	function arraysEqual(a, b) {
		if (a === b) return true;
		if (a == null || b == null) return false;
		if (a.length !== b.length) return false;

		for (var i = 0; i < a.length; ++i) {
			if (a[i] !== b[i]) return false;
		}
		return true;
	}

	return {
		init: init
	};
})();
